import { StatsigClient } from "@statsig/js-client";
import {
  StatsigOptions,
  StatsigUser,
  useClientAsyncInit,
} from "@statsig/react-bindings";
import { useAccountId, useContact } from "@utils/hooks";
import * as React from "react";

const STATSIG_CLIENT_KEY = import.meta.env.VITE_STATSIG_CLIENT_KEY;
const USER_NODE_ENV = import.meta.env.VITE_NODE_ENV;

export function useAsyncClient(): {
  isLoading: boolean;
  statsigClient?: StatsigClient;
} {
  const { contact, loading: isContactLoading, team } = useContact();
  const [loggedInUserId, isAdmin] = useAccountId();

  const statsigUser: StatsigUser = React.useMemo(
    () => ({
      userID: contact?.id,
      email: contact?.email,
      custom: {
        loggedInUserId,
        isAdmin,
        teamId: team?.value,
      },
    }),
    [contact, loggedInUserId, isAdmin, team]
  );

  const statsigOptions: StatsigOptions = React.useMemo(
    () => ({
      environment: { tier: USER_NODE_ENV },
    }),
    []
  );

  const { client, isLoading: isClientLoading } = useClientAsyncInit(
    STATSIG_CLIENT_KEY,
    statsigUser,
    statsigOptions
  );

  return {
    statsigClient: client,
    isLoading: isClientLoading || isContactLoading,
  };
}
